import React from 'react'
import { Banner } from 'src/components/Banner'
import { Button } from 'src/components/Button'
import { Input } from 'src/components/Input'
import { DefaultFormStyle as S } from 'src/pages/DefaultJoinFormPage/styled'
import DefaultFooter from 'src/components/Footer/DefaultFooter'
import PaidNoticeText from 'src/components/PaidNoticeText'
import AgencyTabList from 'src/components/AgencyTabList'
import RenderIf from 'src/components/RenderIf'
import { useFormContext } from 'react-hook-form'
import { AllTermsBooleanType, JoinFormType } from 'src/types/react-hook-form'
import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage/index'

const DefaultJoinFormPageView = (props: DefaultJoinFormPageProps) => {
  const {
    dynamicUiData: { FooterContent, NotiContent, ButtonMsgAfter, TopImage, MiddleImage, UIData },
    registerAttributeExcludeAllTerms: termsData,
    resetFormItems,
    registerAttribute,
    otpCertRequest,
    otpCertVerify,
    count,
  } = props

  const {
    handleSubmit,
    getValues,
    register,
    formState: { touchedFields },
  } = useFormContext<JoinFormType>()
  const { layoutsFooter, layoutsInsert, layoutsTerms, layoutsVerify, layoutsConfirm } = UIData
  const handleSubmitOtpCertRequest = handleSubmit(otpCertRequest.submit, otpCertRequest.error)
  const handleSubmitOtpVerify = handleSubmit(otpCertVerify.submit, otpCertVerify.error)

  return (
    <S.DefaultFormContainer>
      {/*배너*/}
      <Banner.Container>
        <Banner.Items img={TopImage} id="top_Image" />
        <Banner.Items img={MiddleImage} id="middle_Image" />
      </Banner.Container>
      <S.CertFormContainer onSubmit={(e) => e.preventDefault()} $mainBg={layoutsInsert?.mainBg}>
        {/*통신사선택*/}
        <AgencyTabList {...props} layoutsInsert={layoutsInsert} />
        <S.CertFormContents $gap={layoutsInsert?.certs?.type}>
          {/*휴대폰번호 Input*/}
          <Input.PNumber
            registerAttribute={registerAttribute}
            keyDownFunc={handleSubmitOtpCertRequest}
            style={S.CertInputStyle({ touch: true, ...layoutsInsert?.certs })}
          />
          {/*인증번호 발송 Button*/}
          <Button.OtpCertRequest
            onClick={handleSubmitOtpCertRequest}
            renderIf={getValues('TranID') === ''}
            $style={S.OtpRequestButton({ ...layoutsConfirm?.submitBtn })}
          />
          <RenderIf when={getValues('TranID') !== ''}>
            <S.OtpFormContainer>
              <S.ApprovalNumberContainer>
                <S.ApprovalNumberInputWrap>
                  {/*인증번호 Input*/}
                  <Input.ApprovalNumber
                    registerAttribute={registerAttribute}
                    keyDownFunc={handleSubmitOtpVerify}
                    style={S.CertInputStyle({
                      touch: touchedFields?.ApprovalNumber !== undefined,
                      ...layoutsInsert?.certs,
                    })}
                  />
                  {/*타이머*/}
                  <S.Timer>{count?.substring(4, 12)}</S.Timer>
                </S.ApprovalNumberInputWrap>
              </S.ApprovalNumberContainer>
              {/*재전송 버튼*/}
              <Button.RetryOtpCertRequest
                $style={S.RetryRequestButton}
                onClick={handleSubmitOtpCertRequest}
              />
            </S.OtpFormContainer>
          </RenderIf>
        </S.CertFormContents>
        {/*약관 동의 체크박스*/}
        <S.JoinTermsWrap>
          <S.JoinTermsItem type="all">
            <S.FormCheckboxLabel type={'all'}>
              <S.FormCheckbox
                $actColor={layoutsTerms?.actColor}
                {...register('allTerms', registerAttribute.allTerms?.register_options)}
                onClick={registerAttribute.allTerms?.register_options?.onClick}
              />
              필수약관 모두 동의
            </S.FormCheckboxLabel>
          </S.JoinTermsItem>
          {termsData?.map((termsItems) => {
            const { tag, termsTitle, register_options, showTermsPopup } = termsItems
            return (
              <S.JoinTermsItem type="each" key={tag}>
                <S.FormCheckboxLabel type={'each'}>
                  <S.FormCheckbox
                    $actColor={layoutsTerms?.actColor}
                    {...register(tag as keyof AllTermsBooleanType, register_options)}
                  />
                  {termsTitle}
                </S.FormCheckboxLabel>
                <S.JoinTermsOpenDesc onClick={showTermsPopup}>보기</S.JoinTermsOpenDesc>
              </S.JoinTermsItem>
            )
          })}
        </S.JoinTermsWrap>
        {/*가입 Button*/}
        <Button.JoinSubmit
          onClick={handleSubmitOtpVerify}
          $style={S.JoinButton({ ...layoutsVerify?.verifyBtn })}
          name={ButtonMsgAfter}
        />
        {/*취소 Button*/}
        <Button.CancelReset
          onClick={resetFormItems}
          $style={S.CancelReset({ ...layoutsVerify?.cancelBtn })}
        />
      </S.CertFormContainer>
      {/*유료고지문구*/}
      <PaidNoticeText NotiContent={NotiContent} notiCashSpace={layoutsVerify?.cashSpace} />
      {/*푸터*/}
      <DefaultFooter content={FooterContent} layoutsFooter={layoutsFooter} />
    </S.DefaultFormContainer>
  )
}
export default DefaultJoinFormPageView
